/** Must match Vedify-Backend/constants/featuredActionTypes.js */
export const FEATURED_ACTION_TYPES = [
  'lesson',
  'chapter',
  'talk_to_krishna',
  'dhyaan_session',
  'dhyaan_home',
  'contest_rules',
  'vedify_ai',
  'infinite_plan',
  'leaderboard',
  'quest_daily',
  'quest_monthly',
  'vedify_web',
  'referral_share',
  'specific_module',
];

export const FEATURED_MEDIA_TYPES = ['image', 'video', 'gif'];

export const FEATURED_ACTION_OPTIONS = [
  { value: 'lesson', label: 'Lesson' },
  { value: 'chapter', label: 'Chapter' },
  { value: 'talk_to_krishna', label: 'Talk to Krishna' },
  { value: 'dhyaan_session', label: 'Dhyaan session' },
  { value: 'dhyaan_home', label: 'Dhyaan home' },
  { value: 'contest_rules', label: 'Contest rules' },
  { value: 'vedify_ai', label: 'Vedify AI' },
  { value: 'infinite_plan', label: 'Infinite plan' },
  { value: 'leaderboard', label: 'Leaderboard' },
  { value: 'quest_daily', label: 'Daily quest' },
  { value: 'quest_monthly', label: 'Monthly quest' },
  { value: 'vedify_web', label: 'Web URL' },
  { value: 'referral_share', label: 'Referral share' },
  { value: 'specific_module', label: 'Specific Module' },
];

export const HEX_COLOR_RE = /^#[0-9A-Fa-f]{6}$/;

export const emptyFeaturedForm = () => ({
  media_url: '',
  media_type: 'image',
  thumbnail_url: '',
  title: '',
  description: '',
  tag_title: '',
  button_title: '',
  button_color: '#58327E',
  button_border_color: '#58327E',
  button_text_color: '#FFFFFF',
  action_type: 'talk_to_krishna',
  lesson_id: '',
  chapter_id: '',
  session_id: '',
  module_id: '',
  url: '',
  is_active: true,
});

export const normalizeFeaturedActionRef = (actionType, form) => {
  if (actionType === 'lesson') return { lesson_id: String(form.lesson_id || '').trim() };
  if (actionType === 'chapter') return { chapter_id: String(form.chapter_id || '').trim() };
  if (actionType === 'dhyaan_session') {
    const sessionId = String(form.session_id || '').trim();
    return sessionId ? { session_id: sessionId } : {};
  }
  if (actionType === 'contest_rules') return { module_id: String(form.module_id || '').trim() };
  if (actionType === 'specific_module') {
    const out = { module_id: String(form.module_id || '').trim() };
    const chapterId = String(form.chapter_id || '').trim();
    if (chapterId) out.chapter_id = chapterId;
    return out;
  }
  if (actionType === 'vedify_web') return { url: String(form.url || '').trim() };
  return {};
};

export const validateFeaturedForm = (form) => {
  const errors = {};
  if (!String(form.title || '').trim()) errors.title = 'Title is required';
  if (!String(form.description || '').trim()) errors.description = 'Description is required';
  if (!String(form.tag_title || '').trim()) errors.tag_title = 'Tag is required';
  if (!String(form.button_title || '').trim()) errors.button_title = 'Button title is required';
  if (!String(form.media_url || '').trim()) errors.media_url = 'Media URL is required';
  if (!FEATURED_MEDIA_TYPES.includes(form.media_type)) errors.media_type = 'Pick image, video, or gif';
  if (form.media_type === 'video' && !String(form.thumbnail_url || '').trim()) {
    errors.thumbnail_url = 'Thumbnail is required for video';
  }
  if (!FEATURED_ACTION_TYPES.includes(form.action_type) || form.action_type === 'short_videos') {
    errors.action_type = 'Pick a valid action';
  }
  ['button_color', 'button_border_color', 'button_text_color'].forEach((key) => {
    if (!HEX_COLOR_RE.test(String(form[key] || ''))) errors[key] = 'Use #RRGGBB';
  });
  if (form.action_type === 'lesson' && !form.lesson_id) errors.lesson_id = 'No active lesson to bind';
  if (form.action_type === 'chapter' && !form.chapter_id) errors.chapter_id = 'No active chapter to bind';
  if (form.action_type === 'contest_rules' && !form.module_id) errors.module_id = 'Pick a module';
  if (form.action_type === 'specific_module' && !form.module_id) errors.module_id = 'Pick a module';
  if (form.action_type === 'vedify_web' && !String(form.url || '').trim()) errors.url = 'URL is required';
  return errors;
};

export const sequentialFeaturedOrders = (cards) =>
  (cards || []).map((card) => ({
    featured_card_id: String(card._id || card.featured_card_id),
  }));
